import React from "react";
import {
  TableContainer,
  Table as TableMUI,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Tooltip,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PropTypes from "prop-types";

import StyledCell from "./StyledCell";
import months from "./constants";

const useStyles = makeStyles(() => ({
  table: {
    minWidth: 600,
  },
  yearF: {
    textAlign: "center",
    backgroundColor: "rgb(2,31,71)",
    color: "white",
    fontWeight: "bold",
    borderColor: "white",
  },
  hrReportsColumn: {
    width: 250,
  },
  description: {
    maxWidth: 16,
    width: 16,
    minWidth: 16,
  },
  name: {
    width: 80,
    backgroundColor: "rgb(2,31,71)",
    color: "white",
    fontWeight: "bold",
  },
  icon: {
    color: "rgba(2,31,71, 0.5)",
    cursor: "pointer",
    "&:hover": {
      color: "rgb(2,31,71)",
    },
  },
}));

/**
 * isLastIndex
 * @param {Object} obj Object to evaluate Entries
 * @param {number} index Index of current element
 * @param {Boolean} isObject If is Object get the entries.
 * @returns {Boolean} if is the last element
 */
const isLastIndex = (obj, index, isObject = false) => {
  if (isObject) {
    return Object.entries(obj).length - 1 === index;
  } else {
    return obj.length - 1 === index;
  }
};

const styles = {
  notLast: {
    borderLeftColor: "gainsboro",
    borderRightColor: "gainsboro",
    borderStyle: "ridge",
    borderWidth: 1,
  },
  lastMonth: {
    borderRightColor: "white",
    borderRightWidth: "1px",
    borderRightStyle: "solid",
  },
};

const Table = ({ data, fiscalYear = "" }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <TableMUI aria-label="simple table" className={classes.table} size="small">
        <TableHead>
          <TableRow size="small">
            <TableCell
              className={classes.name}
              rowSpan={2}
              size="small"
              style={{
                borderRightColor: "white",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                height: 40,
                width: 40,
              }}
            >
              {"HR Reports"}
            </TableCell>
            <TableCell
              key={`FinancialYear-${fiscalYear}`}
              className={classes.yearF}
              colSpan={12}
              size="small"
              style={{
                borderRightColor: "white",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
              }}
            >
              {fiscalYear}
            </TableCell>
            {/* <TableCell
              key={`FinancialYear-${proxYear}`}
              className={classes.yearF}
              colSpan={12}
              size="small"
            >
              {proxYear}-{getProxYear(proxYear)}
            </TableCell> */}
          </TableRow>
          <TableRow size="small">
            {months.map((m, i) => (
              <StyledCell key={`FY-${fiscalYear}Month-${m}-${i}`} className={classes.yearF}>
                {m}
              </StyledCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody size="small">
          {data?.map(({ name, info, fiscalYear }) => (
            <TableRow key={`Table-Row-${name}`} size="small">
              <TableCell className={classes.name} size="small">
                <Typography variant="subtitle2">{name}</Typography>
              </TableCell>
              {months.map((_, index) => {
                let arrayInfo = [];

                info.map((x) => {
                  if (x.monthNumber === index + 1) {
                    arrayInfo[index + 1] = x.url;
                  }
                });

                let value = arrayInfo[index + 1];

                return (
                  <StyledCell
                    key={`Cell-${name}-${index}`}
                    size="small"
                    style={!isLastIndex(months, index) ? styles.notLast : {}}
                  >
                    {value ? (
                      <Tooltip
                        key={`Tooltip-${name}-${value}-${fiscalYear}`}
                        title="Open in new Tab"
                      >
                        <IconButton
                          href={value}
                          rel="noopener noreferrer"
                          size="small"
                          target="_blank"
                        >
                          <AssignmentTurnedInIcon className={classes.icon} fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </StyledCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </TableMUI>
    </TableContainer>
  );
};

Table.propTypes = {
  data: PropTypes.arrayOf(Object).isRequired,
  fiscalYear: PropTypes.string.isRequired,
};

export default Table;
